module.exports = __webpack_public_path__ + "8465198b8cad8004306556decbbc817a.svg";